<template>
  <svg
    class="custom-icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="icon"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.41032 4.30641C2.85883 4.30022 3.27607 4.44484 3.60897 4.69578C3.65642 4.64989 3.70777 4.60807 3.76576 4.57731L7.51805 2.57839C7.54361 2.56687 7.56917 2.55536 7.59807 2.54733C7.57821 2.41954 7.56512 2.29225 7.56676 2.16065C7.58149 0.983829 8.51193 0.0158005 9.64339 0.000192372C10.7788 -0.0154701 11.6814 0.927242 11.6667 2.10409C11.6519 3.28094 10.7254 4.24888 9.59003 4.26454C9.00425 4.27262 8.47591 4.02438 8.10881 3.6159C8.0832 3.63152 8.0615 3.65062 8.03255 3.66218L4.3059 5.64547C4.38988 5.88516 4.43695 6.14004 4.43356 6.41089C4.43017 6.68175 4.37614 6.93802 4.2867 7.1801L6.61374 8.38101C6.64241 8.39178 6.66421 8.41027 6.68887 8.42521C7.0663 8.00645 7.60104 7.74355 8.18684 7.73547C9.32223 7.7198 10.2248 8.66251 10.2101 9.83936C10.1954 11.0162 9.2689 11.9841 8.13348 11.9998C7.00204 12.0154 6.09549 11.0728 6.11021 9.89592C6.11186 9.76431 6.12815 9.63602 6.15121 9.50824C6.1225 9.501 6.09722 9.49019 6.07194 9.47938L3.71963 8.26354C3.66239 8.23437 3.61207 8.19336 3.56575 8.14935C3.22646 8.40956 2.80487 8.56576 2.35693 8.57194C1.22154 8.5876 0.318946 7.64489 0.333674 6.46804C0.348401 5.29122 1.27488 4.32325 2.4103 4.30759L2.41032 4.30641Z"
      />
    </g>
  </svg>
</template>
